/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_DealInputs */

const cs_model_deal = /** @type {(inputs: Model_DealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obchod`)
};

const en_model_deal = /** @type {(inputs: Model_DealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal`)
};

/**
* | output |
* | --- |
* | "Deal" |
*
* @param {Model_DealInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const model_deal = /** @type {((inputs?: Model_DealInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_DealInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_model_deal(inputs)
	return cs_model_deal(inputs)
});